export const VideoTest = [
    'ddt:v1.1',
    [
        'Graphic',
        '$LWRIN2ITNGMYOC04OGFJLTK4OGUZYMQ5YMMWYY82',
        {
            'width': 1000,
            'height': 800,
            'x': 0,
            'y': 0,
            'rotation': 0,
            'url': 'https://s.metroretro.io/app/haug/20010-private-writing.mp4',
        },
        []
    ]
];

export const GoodBadZones = [
    'ddt:v1.1',
    [
        'Zone',
        'GoodZone',
        {
            'title|value': 'Good things',
            'emoji|value': '😀',
            'width': 478,
            'height': 508,
            'x': -488,
            'y': 0,
            'rotation': 0,
            'autoColor': '#66c0b7',
            'border': [
                50,
                0,
                0,
                0
            ],
            'headingOffset': 0,
            'headingStyle': 'classic',
            'headingPosition': 'left'
        },
        []
    ],
    [
        'Zone',
        'BadZone',
        {
            'title|value': 'Bad things',
            'emoji|value': '😩',
            'width': 478,
            'height': 508,
            'x': 10,
            'y': 0,
            'rotation': 0,
            'autoColor': '#f178a1',
            'border': [
                0,
                0,
                50,
                0
            ],
            'headingOffset': 0,
            'headingStyle': 'classic',
            'headingPosition': 'left'
        },
        []
    ]
];

export const VideoProp1 = [
    'ddt:v1.1',
    [
        'Shape',
        '$LWE2NDUTNDDJNS05NZNILTUYYTI5YJCXMWZJZS8Z',
        {
            'kind': 1,
            'sides': 4,
            'background': '#cbcbcb',
            'width': 356,
            'height': 204,
            'x': 60,
            'y': -260,
            'rotation': 0,
            'content': 'VIDEO'
        },
        []
    ]
];

export const VideoProp2 = [
    'ddt:v1.1',
    [
        'Shape',
        '$LTIYNDQTNGY5YI05Y2RJLTRLODJIODCYMJNJZS82',
        {
            'kind': 1,
            'sides': 4,
            'background': '#cbcbcb',
            'width': 356,
            'height': 204,
            'x': -900,
            'y': 270,
            'rotation': 0,
            'content': 'VIDEO'
        },
        []
    ]
];

export const VideoProp3 = [
    'ddt:v1.1',
    [
        'Shape',
        '$LTC5MJATNGJHZS1IOTFILWFJMWQ5NTHHZDQWMC8Z',
        {
            'kind': 1,
            'sides': 4,
            'background': '#cbcbcb',
            'width': 356,
            'height': 204,
            'x': 520,
            'y': 220,
            'rotation': 0,
            'content': 'VIDEO'
        },
        []
    ]
];

export const VideoProp4 = [
    'ddt:v1.1',
    [
        'Shape',
        '$LWE4NMUTNGE4MS1HMWQXLTRMNGM3NMVIOTY3ZS8ZMA==',
        {
            'kind': 1,
            'sides': 4,
            'background': '#cbcbcb',
            'width': 1260,
            'height': 800,
            'x': -1210,
            'y': 250,
            'rotation': 0,
            'content': 'VIDEO GOES HERE',
            'fontSize': 48
        },
        []
    ]
];

export const StartInstructions = [
    'ddt:v1.1',
    [
        'Text',
        '$LWE4NMUTNGE4MS1HMWQXLTRMNGM3NMVIOTY3ZS8YOA==',
        {
            'y': -250,
            'x': -450,
            'width': 420,
            'rotation': 0,
            'height': 162,
            'fontSize': 18,
            'fontFamily': 'Inter',
            'fontColor': '#546077',
            'content': 'To get started and reveal additional functionality you need to start your meeting.\n' +
                '\nClick on \'Start Meeting\' at the top of the screen.\n' +
                '\nLock your layout for this session so no accidental layout edits happen.',
            'autoWidth': false,
            'autoHeight': true
        },
        []
    ],
    [
        'Text',
        '$LWE4NMUTNGE4MS1HMWQXLTRMNGM3NMVIOTY3ZS8YOQ==',
        {
            'fontSize': 20,
            'fontColor': '#546077',
            'fontFamily': 'Inter',
            'autoWidth': false,
            'x': -450,
            'y': -300,
            'rotation': 0,
            'width': 190,
            'height': 29,
            'autoHeight': true,
            'content': 'Start your Session'
        },
        []
    ]
];

export const MoveInstructions = [
    'ddt:v1.1',
    [
        'Text',
        '$LWE2NDUTNDDJNS05NZNILTUYYTI5YJCXMWZJZS8X',
        {
            'y': -250,
            'x': -450,
            'width': 440,
            'rotation': 0,
            'height': 184,
            'fontSize': 18,
            'fontFamily': 'Inter',
            'fontColor': '#546077',
            'content': 'Click and drag with your mouse to move the camera up and down. Use your scroll wheel to zoom in and out.\n' +
                '\nOR\n\nOn a laptop, slide two-fingers left, right up or down to move the camera. Pinch to zoom in or out',
            'autoWidth': false,
            'autoHeight': true
        },
        []
    ],
    [
        'Text',
        '$LWE2NDUTNDDJNS05NZNILTUYYTI5YJCXMWZJZS8Y',
        {
            'y': -300,
            'x': -450,
            'width': 310,
            'rotation': 0,
            'height': 29,
            'fontSize': 20,
            'fontFamily': 'Inter',
            'fontColor': '#546077',
            'content': 'How to move around the board',
            'autoWidth': false,
            'autoHeight': true
        },
        []
    ]
];

export const CreateInstructions = [
    'ddt:v1.1',
    [
        'Text',
        '$LTIYNDQTNGY5YI05Y2RJLTRLODJIODCYMJNJZS80',
        {
            'y': 0,
            'x': -900,
            'width': 330,
            'rotation': 0,
            'height': 29,
            'fontSize': 20,
            'fontFamily': 'Inter',
            'fontColor': '#546077',
            'content': 'Creating and moving a sticky note',
            'autoWidth': false,
            'autoHeight': true
        },
        []
    ],
    [
        'Text',
        '$LTIYNDQTNGY5YI05Y2RJLTRLODJIODCYMJNJZS81',
        {
            'y': 40,
            'x': -900,
            'width': 410,
            'rotation': 0,
            'height': 184,
            'fontSize': 18,
            'fontFamily': 'Inter',
            'fontColor': '#546077',
            'content': 'Double-click on the board at the position you want to add a sticky note.\n' +
                '\nWrite on your sticky note and click anywhere off the sticky note to apply the change.\n' +
                '\nTo move your sticky note, select it, hold down click and drag it to reposition.',
            'autoWidth': false,
            'autoHeight': true
        },
        []
    ]
];

export const SelectInstructions = [
    'ddt:v1.1',
    [
        'Text',
        '$LTC5MJATNGJHZS1IOTFILWFJMWQ5NTHHZDQWMC8X',
        {
            'y': 40,
            'x': 520,
            'width': 420,
            'rotation': 0,
            'height': 139,
            'fontSize': 18,
            'fontFamily': 'Inter',
            'fontColor': '#546077',
            'content': 'Hold Shift and then drag to make a selection of multiple sticky notes.\n' +
                '\nIf you want to individually select multiple sticky notes, ' +
                'hold CTRL/CMD and click on the sticky notes you want to select.',
            'autoWidth': false,
            'autoHeight': true
        },
        []
    ],
    [
        'Text',
        '$LTC5MJATNGJHZS1IOTFILWFJMWQ5NTHHZDQWMC8Y',
        {
            'y': 0,
            'x': 520,
            'width': 300,
            'rotation': 0,
            'height': 29,
            'fontSize': 20,
            'fontFamily': 'Inter',
            'fontColor': '#546077',
            'content': 'Selecting multiple sticky notes',
            'autoWidth': false,
            'autoHeight': true
        },
        []
    ]
];

export const DeleteInstructions = [
    'ddt:v1.1',
    [
        'Text',
        '$LWJINJYTNDM4ZS1HMTDILTYZN2Q1MZQ2YWFKYI8X',
        {
            'y': 40,
            'x': 520,
            'width': 510,
            'rotation': 0,
            'height': 87,
            'fontSize': 22,
            'fontFamily': 'Inter',
            'fontColor': '#546077',
            'content': 'Select the sticky notes you want to delete and then press the delete or backspace key on your keyboard.',
            'autoWidth': false,
            'autoHeight': true
        },
        []
    ],
    [
        'Text',
        '$LWJINJYTNDM4ZS1HMTDILTYZN2Q1MZQ2YWFKYI8Y',
        {
            'y': 0,
            'x': 520,
            'width': 270,
            'rotation': 0,
            'height': 29,
            'fontSize': 20,
            'fontFamily': 'Inter',
            'fontColor': '#546077',
            'content': 'How to delete a sticky note',
            'autoWidth': false,
            'autoHeight': true
        },
        []
    ]
];

export const RevealInstructions = [
    'ddt:v1.1',
    [
        'Text',
        '$LTEWM2UTNDIWYI05ZTM0LTMXZJGZYJU5MMU1MY80',
        {
            'y': 0,
            'x': -900,
            'width': 250,
            'rotation': 0,
            'height': 29,
            'fontSize': 20,
            'fontFamily': 'Inter',
            'fontColor': '#546077',
            'content': 'Sharing your sticky notes',
            'autoWidth': false,
            'autoHeight': true
        },
        []
    ],
    [
        'Text',
        '$LTEWM2UTNDIWYI05ZTM0LTMXZJGZYJU5MMU1MY81',
        {
            'y': 40,
            'x': -900,
            'width': 360,
            'rotation': 0,
            'height': 184,
            'fontSize': 18,
            'fontFamily': 'Inter',
            'fontColor': '#546077',
            'content': 'Add a sticky note to the board.\n' +
                '\nAt the bottom of your screen you will see a red \'Your stickies are private\' button.\n' +
                '\nClick the button and select \'Make your stickies visible to everyone\'.\n',
            'autoWidth': false,
            'autoHeight': true
        },
        []
    ]
];

export const PingInstructions = [
    'ddt:v1.1',
    [
        'Text',
        '$LTEWM2UTNDIWYI05ZTM0LTMXZJGZYJU5MMU1MY80',
        {
            'y': 0,
            'x': -900,
            'width': 250,
            'rotation': 0,
            'height': 29,
            'fontSize': 20,
            'fontFamily': 'Inter',
            'fontColor': '#546077',
            'content': 'Focus attention with Ping',
            'autoWidth': false,
            'autoHeight': true
        },
        []
    ],
    [
        'Text',
        '$LTEWM2UTNDIWYI05ZTM0LTMXZJGZYJU5MMU1MY81',
        {
            'y': 40,
            'x': -900,
            'width': 370,
            'rotation': 0,
            'height': 117,
            'fontSize': 18,
            'fontFamily': 'Inter',
            'fontColor': '#546077',
            'content': 'With a sticky selected, press TAB on your keyboard.\n\n' +
                'This will show up for your team mates no matter where in the board they are.',
            'autoWidth': false,
            'autoHeight': true
        },
        []
    ]
];

export const ConfettiInstructions = [
    'ddt:v1.1',
    [
        'Text',
        '$LTEWM2UTNDIWYI05ZTM0LTMXZJGZYJU5MMU1MY80',
        {
            'y': 0,
            'x': -900,
            'width': 170,
            'rotation': 0,
            'height': 29,
            'fontSize': 20,
            'fontFamily': 'Inter',
            'fontColor': '#546077',
            'content': 'Celebrate in style',
            'autoWidth': false,
            'autoHeight': true
        },
        []
    ],
    [
        'Text',
        '$LTEWM2UTNDIWYI05ZTM0LTMXZJGZYJU5MMU1MY81',
        {
            'y': 40,
            'x': -900,
            'width': 320,
            'rotation': 0,
            'height': 117,
            'fontSize': 18,
            'fontFamily': 'Inter',
            'fontColor': '#546077',
            'content': 'Click on the lightning bolt in the left menu, select the confetti icon.\n' +
                '\nClick and drag on the whiteboard to load, aim and release for confetti joy!',
            'autoWidth': false,
            'autoHeight': true
        },
        []
    ]
];

export const ShareInstructions = [
    'ddt:v1.1',
    [
        'Text',
        '$LTM4ZMITNGY0NY1IYJDJLTVKMGEXN2ZJNZC5YY8YOA==',
        {
            'y': -640,
            'x': -1210,
            'width': 1410,
            'rotation': 0,
            'height': 404,
            'fontSize': 64,
            'fontFamily': 'Inter',
            'fontColor': '#546077',
            'content': 'With your session structure ready, it\'s time to invite your team and guests.\n' +
                '\nOpen the share options in the top right of your screen to find the board url and adjust access.',
            'autoWidth': false,
            'autoHeight': true
        },
        []
    ],
    [
        'Text',
        '$LTM4ZMITNGY0NY1IYJDJLTVKMGEXN2ZJNZC5YY8ZMQ==',
        {
            'fontSize': 100,
            'fontColor': '#546077',
            'fontFamily': 'Inter',
            'autoWidth': false,
            'x': -1210,
            'y': -830,
            'rotation': 0,
            'width': 1040,
            'height': 129,
            'autoHeight': true,
            'content': 'Sharing and Options:'
        },
        []
    ]
];

export const SessionInstructions = [
    'ddt:v1.1',
    [
        'Text',
        '$LWE4NMUTNGE4MS1HMWQXLTRMNGM3NMVIOTY3ZS8YOA==',
        {
            'y': -640,
            'x': -1210,
            'width': 1560,
            'rotation': 0,
            'height': 804,
            'fontSize': 64,
            'fontFamily': 'Inter',
            'fontColor': '#546077',
            'content': 'Click \'Meeting in Progress\' in the top bar to view and edit meeting settings .\n' +
                '\nLet\'s activate two for the tutorial.\n' +
                '\nReady check so we know the team is good to start and a timer to indicate activity length.\n' +
                '\nFYI, Private writing is on by default so you can manage when sticky notes are revealed.',
            'autoWidth': false,
            'autoHeight': true
        },
        []
    ],
    [
        'Text',
        '$LWE4NMUTNGE4MS1HMWQXLTRMNGM3NMVIOTY3ZS8YOQ==',
        {
            'fontSize': 100,
            'fontColor': '#546077',
            'fontFamily': 'Inter',
            'autoWidth': false,
            'x': -1210,
            'y': -830,
            'rotation': 0,
            'width': 1090,
            'height': 129,
            'autoHeight': true,
            'content': 'Session Management:'
        },
        []
    ]
];

export const VotingInstructions = [
    'ddt:v1.1',
    [
        'Text',
        '$LWE4NMUTNGE4MS1HMWQXLTRMNGM3NMVIOTY3ZS8YOA==',
        {
            'y': -640,
            'x': -1210,
            'width': 1560,
            'rotation': 0,
            'height': 804,
            'fontSize': 64,
            'fontFamily': 'Inter',
            'fontColor': '#546077',
            'content': 'To start a round, select the +1 icon from the left menu and then select \'Start Voting Round\'.\n' +
                '\nVote on a few sticky notes.\n\nAs people add their votes you\'ll see medals appear to help track vote scoring.\n' +
                '\nTo clear a round, click on the \'Voting Round\' button and the use the trash can icon.',
            'autoWidth': false,
            'autoHeight': true
        },
        []
    ],
    [
        'Text',
        '$LWE4NMUTNGE4MS1HMWQXLTRMNGM3NMVIOTY3ZS8YOQ==',
        {
            'fontSize': 100,
            'fontColor': '#546077',
            'fontFamily': 'Inter',
            'autoWidth': false,
            'x': -1210,
            'y': -830,
            'rotation': 0,
            'width': 1090,
            'height': 129,
            'autoHeight': true,
            'content': 'Voting Rounds:'
        },
        []
    ]
];

export const ModeInstructions = [
    'ddt:v1.1',
    [
        'Text',
        '$LWE4NMUTNGE4MS1HMWQXLTRMNGM3NMVIOTY3ZS8YOA==',
        {
            'y': -640,
            'x': -1210,
            'width': 1560,
            'rotation': 0,
            'height': 644,
            'fontSize': 64,
            'fontFamily': 'Inter',
            'fontColor': '#546077',
            'content': 'While a meeting is in progress you might want to add a different template, adjust a layout or change your ' +
                'structure completely.\n\nYou can do this by switching between Design and Meeting mode without affecting your session.\n' +
                '\nUse the top left icon to try it out.',
            'autoWidth': false,
            'autoHeight': true
        },
        []
    ],
    [
        'Text',
        '$LWE4NMUTNGE4MS1HMWQXLTRMNGM3NMVIOTY3ZS8YOQ==',
        {
            'fontSize': 100,
            'fontColor': '#546077',
            'fontFamily': 'Inter',
            'autoWidth': false,
            'x': -1210,
            'y': -830,
            'rotation': 0,
            'width': 1090,
            'height': 129,
            'autoHeight': true,
            'content': 'Mode Switching:'
        },
        []
    ]
];

export const ConfettiInstructions2 = [
    'ddt:v1.1',
    [
        'Text',
        '$LWE4NMUTNGE4MS1HMWQXLTRMNGM3NMVIOTY3ZS8YOA==',
        {
            'y': -640,
            'x': -1210,
            'width': 1560,
            'rotation': 0,
            'height': 644,
            'fontSize': 64,
            'fontFamily': 'Inter',
            'fontColor': '#546077',
            'content': 'When all activities are done, why not celebrate a bit.\n\n' +
                'Click on the lightning bolt in the left menu, select the confetti icon.\n\n' +
                'Click and drag on the whiteboard to load, aim and release for confetti joy!',
            'autoWidth': false,
            'autoHeight': true
        },
        []
    ],
    [
        'Text',
        '$LWE4NMUTNGE4MS1HMWQXLTRMNGM3NMVIOTY3ZS8YOQ==',
        {
            'fontSize': 100,
            'fontColor': '#546077',
            'fontFamily': 'Inter',
            'autoWidth': false,
            'x': -1210,
            'y': -830,
            'rotation': 0,
            'width': 1090,
            'height': 129,
            'autoHeight': true,
            'content': 'Celebrate in style:'
        },
        []
    ]
];

export const EndInstructions = [
    'ddt:v1.1',
    [
        'Text',
        '$LWE4NMUTNGE4MS1HMWQXLTRMNGM3NMVIOTY3ZS8YOA==',
        {
            'y': -640,
            'x': -1210,
            'width': 1560,
            'rotation': 0,
            'height': 644,
            'fontSize': 64,
            'fontFamily': 'Inter',
            'fontColor': '#546077',
            'content': 'To end the meeting for all participants click on the \'Meeting in Progress\' ' +
                'indicator in the top bar and select End Meeting.',
            'autoWidth': false,
            'autoHeight': true
        },
        []
    ],
    [
        'Text',
        '$LWE4NMUTNGE4MS1HMWQXLTRMNGM3NMVIOTY3ZS8YOQ==',
        {
            'fontSize': 100,
            'fontColor': '#546077',
            'fontFamily': 'Inter',
            'autoWidth': false,
            'x': -1210,
            'y': -830,
            'rotation': 0,
            'width': 1090,
            'height': 129,
            'autoHeight': true,
            'content': 'Well that was fun!'
        },
        []
    ]
];

export const ExportInstructions = [
    'ddt:v1.1',
    [
        'Text',
        '$LWE4NMUTNGE4MS1HMWQXLTRMNGM3NMVIOTY3ZS8YOA==',
        {
            'y': -640,
            'x': -1210,
            'width': 1560,
            'rotation': 0,
            'height': 644,
            'fontSize': 64,
            'fontFamily': 'Inter',
            'fontColor': '#546077',
            'content': 'To export information from your board, multi-select individual objects and right-click, ' +
                'or just right-click anywhere on the board and select Export for a list of options.',
            'autoWidth': false,
            'autoHeight': true
        },
        []
    ],
    [
        'Text',
        '$LWE4NMUTNGE4MS1HMWQXLTRMNGM3NMVIOTY3ZS8YOQ==',
        {
            'fontSize': 100,
            'fontColor': '#546077',
            'fontFamily': 'Inter',
            'autoWidth': false,
            'x': -1210,
            'y': -830,
            'rotation': 0,
            'width': 1090,
            'height': 129,
            'autoHeight': true,
            'content': 'Gaining Insight:'
        },
        []
    ]
];

